function updateCookieNoticeStatus() {
  var cookieNotice = document.getElementById("cookie-notice");
  var statusNode = document.getElementById("cookie-notice-status");
  var resetButton = document.getElementById("cookie-notice-reset");

  if (!statusNode || !resetButton) {
    return;
  }

  if (cookieNotice) {
    statusNode.innerHTML = "<strong>Status:</strong> Cookie notice is visible.";
    resetButton.disabled = true;
    resetButton.title = "Cookie notice is already visible.";
  } else {
    statusNode.innerHTML = "<strong>Status:</strong> Cookie notice is dismissed.";
    resetButton.disabled = false;
    resetButton.title = "Restore the cookie notice to run the demo again.";
  }
}

function bindCookieNoticeCloseBehavior() {
  var cookienotice = document.getElementById("cookie-notice");
  var cookiebutton = cookienotice && cookienotice.getElementsByTagName("button")[0];

  if (cookiebutton == null) {
    return;
  }

  cookiebutton.title = "Dismiss Cookie Notice";

  cookiebutton.addEventListener("click", function () {
    cookienotice.classList.add("closing");
    cookienotice.style.height = cookienotice.offsetHeight + "px";

    setTimeout(function () {
      cookienotice.style.height = "0px";
    }, 1); // 500ms is resize mixin duration

    setTimeout(function () {
      cookienotice.remove();
      document.dispatchEvent(new CustomEvent("refreshFrame"));
      updateCookieNoticeStatus();
    }, 500); // 500ms is resize mixin duration
  });
}

bindCookieNoticeCloseBehavior();

var cookieResetButton = document.getElementById("cookie-notice-reset");
if (cookieResetButton) {
  cookieResetButton.addEventListener("click", function () {
    if (document.getElementById("cookie-notice")) {
      return;
    }

    var stickyAttachment = document.getElementById("stickyattachmentcontent");
    if (!stickyAttachment) {
      return;
    }

    stickyAttachment.insertAdjacentHTML(
      "afterbegin",
      '<div id="cookie-notice" class="clearfix">' +
        '<button type="button" title="Dismiss Cookie Notice">OK</button>' +
        '<p>I store cookies to help optimize my website. Learn more or change how my site stores them by visiting my <a href="/_archive/policy/cookie">Cookie Policy</a>.</p>' +
      "</div>"
    );

    bindCookieNoticeCloseBehavior();
    document.dispatchEvent(new CustomEvent("refreshFrame"));
    updateCookieNoticeStatus();
  });
}

updateCookieNoticeStatus();
